<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="planType" label="计划类型">
              {{ planTypeMap.get(formData.planType) || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="dateDay" label="计划日期">
              {{ formData.dateDay || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="planNum" label="计划产能">
              {{ formData.planNum || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleNum" :label="formData.planType === '1' ? '允许大车数量' : '允许罐车数量'">
              {{ formData.vehicleNum || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="startTime" label="生效时间">
              {{ formData.startTime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ctime" label="创建时间">
              {{ formData.ctime || '--' }}
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
import { planType } from '@/utils/dict'

export default {
  name: 'PlanSettingDetail',
  data() {
    return {
      planTypeMap: planType,
      formData: {
        dateId: '', // 计划id
        dateDay: '', // 日期
        planNum: '', // 计划产能
        vehicleNum: '', // 允许大车数量
        createUserId: '', // 创建人
        ctime: '', // 创建时间
        startTime: '' // 生效时间
      }
    }
  },
  created() {
    if (this.dateId) {
      this.loadData()
    }
  },
  computed: {
    dateId() {
      return this.$route.query.dateId
    }
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.clyy.selectWlVehicleDateByDateId, { dateId: this.dateId }).then(res => {
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
